export const BUTTON_VARIANT_CLASSES = {
  primary: {
    default: 'bg-blue-800 hover:bg-blue-900 text-white',
    loading: 'bg-blue-200',
    outline:
      'bg-transparent border border-blue-800 text-blue-800 hover:bg-blue-900 hover:text-white',
    disabled: 'bg-gray-200 text-gray-600',
    outlineDisabled: 'bg-transparent border border-gray-200 text-gray-500',
  },
  secondary: {
    default: 'bg-gray-800 hover:bg-gray-900 text-white',
    loading: 'bg-gray-200',
    outline:
      'bg-transparent border border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white',
    disabled: 'bg-gray-200 text-gray-600',
    outlineDisabled: 'bg-transparent border border-gray-200 text-gray-500',
  },
  danger: {
    default: 'bg-red-800 hover:bg-red-900 text-white',
    loading: 'bg-red-200',
    outline: 'bg-transparent border border-red-800 text-red-800 hover:bg-red-900 hover:text-white',
    disabled: 'bg-gray-200 text-gray-600',
    outlineDisabled: 'bg-transparent border border-gray-200 text-gray-500',
  },
  success: {
    default: 'bg-green-800 hover:bg-green-900 text-white',
    loading: 'bg-green-200',
    outline:
      'bg-transparent border border-green-800 text-green-800 hover:bg-green-900 hover:text-white',
    disabled: 'bg-gray-200 text-gray-600',
    outlineDisabled: 'bg-transparent border border-gray-200 text-gray-500',
  },
  warning: {
    default: 'bg-yellow-800 hover:bg-yellow-900 text-white',
    loading: 'bg-yellow-200',
    outline:
      'bg-transparent border border-yellow-800 text-yellow-800 hover:bg-yellow-900 hover:text-white',
    disabled: 'bg-gray-200 text-gray-600',
    outlineDisabled: 'bg-transparent border border-gray-200 text-gray-500',
  },
  none: {
    default: '',
    loading: '',
    outline: '',
    disabled: 'text-gray-200',
    outlineDisabled: 'text-gray-200',
  },
  white: {
    default: 'bg-white text-gray-700 hover:bg-gray-100',
    loading: 'bg-white text-gray-700 hover:bg-gray-100',
    outline:
      'bg-transparent border border-gray-50 hover:border-gray-100 text-white hover:bg-gray-100/60 hover:text-white',
    disabled: 'bg-gray-200 border-gray-300 text-white',
    outlineDisabled: 'bg-transparent border border-gray-200 text-white',
  },
};
